import moment from 'moment';
import LinearProgress from '@material-ui/core/LinearProgress';

import React from 'react';

export const calcRR = (row, put_call, itm_prob, strike) => {
  let RRS;
  let dividedValue = !itm_prob ? 0 : parseFloat(row.close / itm_prob);
  let FixedStrike = parseFloat(strike);
  put_call === 'C'
    ? (RRS = FixedStrike + dividedValue)
    : (RRS = FixedStrike - dividedValue);
  let newRRS = RRS >= 0 ? parseFloat(RRS).toFixed(2) : 0;
  return Number(newRRS);
};

export const LinearProgressWithLabel = () => {
  return <LinearProgress />;
};
export const NormSInv = (p) => {
  var a1 = -39.6968302866538,
    a2 = 220.946098424521,
    a3 = -275.928510446969;
  var a4 = 138.357751867269,
    a5 = -30.6647980661472,
    a6 = 2.50662827745924;
  var b1 = -54.4760987982241,
    b2 = 161.585836858041,
    b3 = -155.698979859887;
  var b4 = 66.8013118877197,
    b5 = -13.2806815528857,
    c1 = -7.78489400243029e-3;
  var c2 = -0.322396458041136,
    c3 = -2.40075827716184,
    c4 = -2.54973253934373;
  var c5 = 4.37466414146497,
    c6 = 2.93816398269878,
    d1 = 7.78469570904146e-3;
  var d2 = 0.32246712907004,
    d3 = 2.445134137143,
    d4 = 3.75440866190742;
  var p_low = 0.02425,
    p_high = 1 - p_low;
  var q, r;
  var retVal;

  if (p < 0 || p > 1) {
    retVal = 0;
  } else if (p < p_low) {
    q = Math.sqrt(-2 * Math.log(p));
    retVal =
      (((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) /
      ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
  } else if (p <= p_high) {
    q = p - 0.5;
    r = q * q;
    retVal =
      ((((((a1 * r + a2) * r + a3) * r + a4) * r + a5) * r + a6) * q) /
      (((((b1 * r + b2) * r + b3) * r + b4) * r + b5) * r + 1);
  } else {
    q = Math.sqrt(-2 * Math.log(1 - p));
    retVal =
      -(((((c1 * q + c2) * q + c3) * q + c4) * q + c5) * q + c6) /
      ((((d1 * q + d2) * q + d3) * q + d4) * q + 1);
  }

  return retVal;
};
export const normalcdf = (mean, sigma, to) => {
  var z = (to - mean) / Math.sqrt(2 * sigma * sigma);
  var t = 1 / (1 + 0.3275911 * Math.abs(z));
  var a1 = 0.254829592;
  var a2 = -0.284496736;
  var a3 = 1.421413741;
  var a4 = -1.453152027;
  var a5 = 1.061405429;
  var erf =
    1 - ((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t * Math.exp(-z * z);
  var sign = 1;
  if (z < 0) {
    sign = -1;
  }
  return (1 / 2) * (1 + sign * erf);
};

export const ITMPROB = (res, puttCall, expiration) => {
  let sigma = res.ivol;

  var a = moment(expiration);
  var b = moment(res.date);
  let diff = a.diff(b, 'days');

  let t = diff / 365.0;
  if (puttCall === 'P') {
    res.delta += 1.0;
  }
  if (
    sigma < 0.0 ||
    isNaN(sigma) ||
    isNaN(res.delta) ||
    res.delta <= 0.0 ||
    res.delta >= 1.0
  ) {
    return 0.0;
  }

  let time_sqrt = Math.sqrt(t);
  let d1 = NormSInv(res.delta);

  let d2 = d1 - sigma * time_sqrt;
  if (puttCall === 'C') {
    return normalcdf(0, 1, d2);
  } else {
    return normalcdf(0, 1, -d2);
  }
};



// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/functions.js